export const EditorEvents = {
    AddTemplatesToCampaign: "addTemplatesToCampaign",
    UpdateEditableSettings: "updateEditableSettings"
} as const;
